const i18n = {
  get: function () {
    return pCloudIntl.__.apply(pCloudIntl, arguments);
  }
};

export default i18n;